export default __webpack_public_path__ + "static/media/frog.c9e9a796.png";